import React from 'react';
import Faq from 'react-faq-component';
import Slider from '../NetflixSlider'
import {  Link } from 'react-router-dom'
import InstructordCard from '../instructor/InstructorCard';
import SliderNew from "react-slick";
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


 
import {
  Container,
  Divider,
  Dropdown,
  Grid,
  Header,
  Image,
  List,
    Icon, 
    Input,
    Button,
  Menu,
    Transition, 
  Segment,
    Visibility,
    Message
} from 'semantic-ui-react'
 /*
  <Grid stackable columns='equal' >
            <Grid.Row only='computer tablet'>
                <Segment  style={{backgroundColor: "black", marginTop: '1em', marginLeft: '2em' }}>
                    <Header as='h2'  inverted textAlign="center">
                       {strings?strings["CursosInperdibles"]:""}
                    </Header>
                    
                    <hr style={{height:'3px',borderWidth:0,color:'gray',backgroundColor:'white'}}>
                    </hr>
                    <div style={{backgroundColor: '#000000'}}> 
                        {datos!=null && datos.length>0? 
                            <Slider>
                                {datos.map(movie => (
                                    <Slider.Item movie={movie} key={movie.id}>item1</Slider.Item>
                                ))}
                            </Slider>
                        :""}
                    </div>
                </Segment>
            </Grid.Row>
            <Grid.Row only='mobile' >
                {datos!=null && datos.length>0? 
                    <Segment  style={{backgroundColor: "black", marginTop: '1em' }} >
                    <Header as='h2'  inverted textAlign="center">
                        {strings?strings["CursosInperdibles"]:""}
                    </Header>
                    
                    <hr style={{height:'3px',borderWidth:0,color:'gray',backgroundColor:'white'}}>
                    </hr>    
                    {datos.map(movie => (
                   
                        <Grid.Column textAlign="center">
                            <Image src={movie.image} fluid as='a'  href={movie.url}  />
                        </Grid.Column>    
                    ))}
                    </Segment>
                 :""
                }
            </Grid.Row>    
    </Grid>
    
     <br/>
      <Message warning
        color="blue"
        size='huge'
        attached
        header='Aviso a la comunidad Quality Academics'
        content='Qualitly Academics estará fuera de línea durante 30 min aproximandamete por manetenimiento a nuestros servidores en un horario de 17:00 horas a 17:30 zona Horaria de CDMX, 18:00 a 18:30 horario de Colombia. Agradecemos su comprensión.'
    />
    <br/>
    
    {idioma=="es"?
        <Image src="./images/BannerAcademics2.jpg" fluid   />
    :
        <Image src="./images/BannerAcademics2_ingles.jpeg" fluid   />
    }
    
                Welcome to Quality Academics, the educational platform of Quality Consulting and Proasecal.
A space to provide clinical laboratory professionals from Latin America and the world with the necessary tools for agile, modern and simple learning, and above all, quality.
We welcome you to our community with more than 10,000 members



 <div className="hidden-mobile">        
    
        <Header as='h2' style={{ marginTop: '1em' }}   textAlign="center">
           {strings?strings["CursosInperdibles"]:""}
        </Header>


        <hr style={{height:'3px',borderWidth:0,color:'gray',backgroundColor:'white'}}>
        </hr>       

         {datos!=null && datos.length>0? 
            <Slider >
                {datos.map(movie => (
                    <Slider.Item movie={movie}  key={movie.id} >item1</Slider.Item>
                ))}
            </Slider>
        :""}


    </div>
    
      {user==null?
                 <Link to="/miespacio" ><Button primary fluid>{strings?strings["EresMiembro"]:""}</Button></Link>
                :""}
    
    {user==null?
    <div>
                <Divider hidden="true"/>
                <Divider  hidden="true" />
                <Divider hidden="true"/>
    </div>
    
    :""}
                {user==null?
                <Link to="/miespacio" ><Button primary fluid>{strings?strings["IngresaMiembro"]:""}</Button></Link>
                :""}
                
                

 */


function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "orange", position: "absolute" }}
      onClick={onClick}
    />

  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "orange" }}
      onClick={onClick}
    />
  );
}

const Home = ({content, datos, homeInfo, instructores, preguntasFrecuentes={},onShowModalInstructor , faq={}, gratuitos, user, overlayFixed=true, strings, idioma, cursoPago,onShowModal }) => { 

 

    const items = homeInfo.imagenes.map((item, index) => {
  
        return <div className="item"  data-value={index + 1} >
            <Image src={"/info/resource/?nombre="+item.ruta} fluid   />
            </div>;
    });
    
    
    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        swipeToSlide: true,
        slidesToScroll: 1,
        arrows: false
      };
 
    return(
  <Segment basic style={{backgroundColor: "white"}} >

        
          <AliceCarousel
        autoPlay
        autoPlayInterval={3000}
        animationDuration={1000}
        
        disableDotsControls
        disableButtonsControls
        autoHeight  
        infinite
        mouseTracking
        items={items}
    />
     
    
    <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css" integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T" crossorigin="anonymous" />
        
    
    <Segment  style={{ padding: '3em 0em', backgroundColor: "white" }} vertical>
      <Container text>
        <Header as='h3'   style={{ fontSize: '2em' }} textAlign="center">
          Quality Academics
        </Header>
     
        
          
     </Container>
        
         <Segment size='massive'> 
        {idioma=="es"?    
            
                <div   style={{ 'text-align': 'justify'}}>
                <h2>{homeInfo.descripcion}</h2>
                </div>    
            :
                <>
        
                {idioma=="en"? 
                    <div   style={{ 'text-align': 'justify'}}>
                    <h2>{homeInfo.descripcionen}</h2>
                    </div>
                :
                    <div   style={{ 'text-align': 'justify'}}>
                    <h2>{homeInfo.descripcionpr}</h2>
                    </div>
        
                }
                </>
        
            }
        </Segment>    
        

              
    
    </Segment>
    
     <Grid stackable columns='equal' only='mobile'  >
           
            <Grid.Row only='mobile' >
                {datos!=null && datos.length>0? 
                    <Segment  style={{backgroundColor: "white" }} >
                        <Header as='h2'   textAlign="center">
                            {strings?strings["CursosInperdibles"]:""}
                        </Header>
                    
                        <hr style={{height:'3px',borderWidth:0,color:'gray',backgroundColor:'white'}}>
                        </hr>    
                        {datos.map(tipo => (
                            <div>
                            {tipo.map(movie => (        
                                <Grid.Column textAlign="center">
                                    <Image src={movie.image} fluid as='a'  href={movie.url}  />
                                </Grid.Column>
                            ))}
                            </div>
                        ))}
                        </Segment>
                 :""
                }
            </Grid.Row>    
    </Grid>
    
            
 
    
    <div className="hidden-mobile">  
        
        <Header as='h2'   textAlign="center">
           {strings?strings["CursosInperdibles"]:""} 
        </Header>
        
        
        {datos.map(tipo => (
            
        <div>   
            {tipo.length>0?
            <Segment Basic> 
                <Header as='h2'   textAlign="center">
                    {strings? strings[tipo[0].tipoStr]:""}
                </Header>
            <SliderNew {...settings}>
                {tipo.map(movie => (

                    <div >
                        <div>        
                        <Image src={movie.image}   />
                        </div>

                        <Segment >
                            <p  style={{'height':'150px',backgroundColor:'white', align:"justify"}}>{movie.desc}</p>

                            <Link to={movie.url} ><Button color="orange" fluid>{strings? strings["masInformacion"]:""}</Button></Link>

                            
                        </Segment>    
                    </div>

               ))}
            </SliderNew>
            <br/><br/>
            </Segment>
            :""        
        }
            
        </div>        
       ))}
        
    </div>    
    <div id="constanciasexternas">
    <Segment basic color="blue" inverted>
    
      <Button fluid size="massive" primary onClick={onShowModal}>DESCARGA AQUÍ TUS CONSTANCIAS DE FOROS: Qualityps, InterQC Topics y Blood in Blood</Button>
   
    </Segment>  
    </div>  
    {homeInfo.cursoMiddle!=null? 
    <Segment basic >
        <Grid stackable columns='equal' >
            <Grid.Row only='computer tablet'>
              <Grid.Column>
            
                    <Image src={homeInfo.cursoMiddle.imageBg} fluid   />
               
             </Grid.Column>
              <Grid.Column verticalAlign="middle" textAlign="center">
                  <Container>
                    <Segment basic>
                        <Header as='h2' ></Header>
                        
                        <Link to={homeInfo.cursoMiddle.url} ><Button primary size="large" >{strings?strings["Suscribete"]:""}</Button> </Link> 
                          
                        </Segment> 
                    </Container>
                </Grid.Column>
            </Grid.Row>

            <Grid.Row only='mobile' >
                <Grid.Column>    
                <Container textAlign="center">            
                    <Image src={homeInfo.cursoMiddle.imageBg}    />
                </Container>
            
                <Container textAlign="center">
                    <Header as='h2' ></Header>
                    <Link to={homeInfo.cursoMiddle.url} ><Button primary size="large" >{strings?strings["Suscribete"]:""}</Button> </Link> 
                </Container>
                </Grid.Column>    
             </Grid.Row>
        </Grid>                
                        
    </Segment >
  :""}




{instructores.length>0?
    <div>
    
    
    

<Segment basic style={{ marginTop: '4em'}}>
    <Header as='h2'   >
        {strings?strings["Nuestroequipo"]:""}
    </Header>
 <hr style={{height:'3px',borderWidth:0,color:'gray',backgroundColor:'white'}}>
   </hr>
   
    <div className="app" > 
    
     <InstructordCard
        strings={strings}
        instructores={instructores}
        onShowModalInstructor={onShowModalInstructor}
        />
    </div>
<Divider hidden/>
  </Segment>
</div>
    :""}
    
    {preguntasFrecuentes!=null && preguntasFrecuentes.rows!=null && preguntasFrecuentes.rows.length>0?
        <Segment basic style={{ marginTop: '4em'}}>
        <Faq data={preguntasFrecuentes}
            styles={{
                    bgColor: "white",
                     
                    titleTextColor: "black",
                    rowTitleColor: "black",
                    rowTitleTextSize: 'large',
                    rowContentColor: "#48484a",
                    rowContentTextSize: '16px',
                    rowContentPaddingTop: '10px',
                    rowContentPaddingBottom: '10px',
                    rowContentPaddingLeft: '50px',
                    rowContentPaddingRight: '150px',
                    arrowColor: "black",
                    }} 


        />
    </Segment>
        :""}
    <div id="pie">
    <Segment inverted vertical style={{ margin: '5em 0em 0em', padding: '5em 0em' }}>
      <Container >
        <Grid divided inverted stackable>
          <Grid.Column width={1}>
            <Header inverted as='h4' content='' />
            <List link inverted>
              <List.Item>                
                <a target="_blank" href='https://www.facebook.com/QualityConsultingLatinoamerica/'>
                  <List.Icon name='facebook square' size="big" />
                  </a> 
                </List.Item>

              <List.Item>
                <a target="_blank" href='https://www.linkedin.com/company/quality-consulting-asesores'>
                  <List.Icon name='linkedin square' size="big" />
                  </a> 
                </List.Item>

                <List.Item>
                <a target="_blank" href='https://www.instagram.com/qualityacademics/?hl=es-la'>
                  <List.Icon name='instagram' size="big" />
                  </a> 
                </List.Item>


                <List.Item>
                <a target="_blank" href='https://www.youtube.com/c/QualityConsulting-QualityAcademics'>
                  <List.Icon name='youtube square' size="big" />
                  </a> 
                </List.Item>
                  
                <List.Item>
                <a target="_blank" href='https://twitter.com/Q_Academics/'>
                  <List.Icon name='twitter square' size="big" />
                  </a> 
                </List.Item>  



            </List>
          </Grid.Column>

<Grid.Column width={3}>
            <Header inverted as='h4' content={strings?strings["QuienesSomos"]:""} />
            <List link inverted>
            
               
            <List.Item>
              <List.Content>
                <List.Icon name='linkify' />
                <a target="_blank"  href='https://www.qsc.com.mx/'>Quality Consulting</a>
              </List.Content>
            </List.Item>
              
            </List>
          </Grid.Column>


          <Grid.Column width={2}>
            <Header inverted as='h4' content={strings?strings["Nuestrasherramientas"]:""} />
            <List link inverted>
            
               
            <List.Item>
              <List.Content>
                <a target="_blank"  href='https://www.qsc.com.mx/green-belt/'>Green Belt</a>
              </List.Content>
            </List.Item>

<List.Item>
              <List.Content>
                <a target="_blank"  href='https://www.qsc.com.mx/black-belt/'>Black Belt</a>
              </List.Content>
            </List.Item>

<List.Item>
              <List.Content>
                <a target="_blank"  href='https://www.qsc.com.mx/orange-belt/'>Orange Belt </a>
              </List.Content>
            </List.Item>

<List.Item>
              <List.Content>
                <a target="_blank"  href='https://www.qsc.com.mx/premium-belt/'>Red Belt</a>
              </List.Content>
            </List.Item>

           <List.Item>
              <List.Content>
                <a target="_blank"  href='https://www.qsc.com.mx/red-belt/'>Premium belt</a>
              </List.Content>
            </List.Item>
                
            <List.Item>
              <List.Content>
                <a target="_blank"  href='https://www.one.green-belt.com.mx'>Green belt one</a>
              </List.Content>
            </List.Item>    
                
          
            </List>
          </Grid.Column>
          
          

<Grid.Column width={3}>
            <Header inverted as='h4' content={strings?strings["QCC"]:""} />
            <List link inverted>
            
               
            <List.Item>
              <List.Icon name='marker' />
              <List.Content>Cra. 13 # 98-70 of.604 edificio OCHIC. Bogotá, Colombia</List.Content>
            </List.Item>


<List.Item>
              <List.Icon name='phone square' />
              <List.Content>{strings?strings["Telefonos"]:""}: (57)3162968728</List.Content>
            </List.Item>

              
              
              
            <List.Item>
              <List.Icon name='mail' />
                 <List.Content> <a href='mailto:contacto@qsc.com.mx'>contacto@qsc.com.mx</a>
               </List.Content>
            </List.Item>             
                 
                 
            </List>
                 
          
          </Grid.Column>



<Grid.Column width={4}>
            <Header inverted as='h4' content={strings?strings["QCM"]:""} />
            <List link inverted>
            
               
            <List.Item>
              <List.Icon name='marker' />
              <List.Content>Calzada de la Viga 1750 int. 21, Colonia Héroes de Churubusco, Alcaldía Iztapalapa (Ciudad de México 01090)</List.Content>
            </List.Item>


<List.Item>
              <List.Icon name='phone square' />
              <List.Content>{strings?strings["Telefonos"]:""}: 0155 5705 9011 / 9012 / 9013 / 9014</List.Content>
            </List.Item>

<List.Item>
              <List.Icon name='mail' />
                 <List.Content> <a href='mailto:contacto@qsc.com.mx'>contacto@qsc.com.mx</a>
               </List.Content>
            </List.Item>
              
            </List>                
                     
    </Grid.Column>




                     <Grid.Column width={3}>
            <Header inverted as='h4' content={strings?strings["constancias"]:""} />
                <List link inverted>     
                <List.Item>   
                    <List.Content>    
                    <a href='#pie' onClick={onShowModal}>{strings?strings["obtenConstancias"]:""}</a>  

                    </List.Content>    
            
               </List.Item>
                </List>    
                     
    </Grid.Column>
                    


        </Grid>

         
        
      </Container>
    </Segment>
    </div>

  </Segment>
);
};
 

export default Home;

